import React from "react";
import { Box, TextField } from "@mui/material";

const SmallTextFormSimple = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  value,
  handleChange,
  handleBlur,
}) => {
  return (
    <Box xs={12} key={orderFormFieldKey} sx={{}}>
      <TextField
        id={orderFormFieldKey}
        name={orderFormFieldKey}
        sx={{ width: "100%" }}
        variant="outlined"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        error={orderFormFieldTouched && Boolean(orderFormFieldError)}
        helperText={(orderFormFieldTouched && orderFormFieldError) || " "}
      />
    </Box>
  );
};

export default SmallTextFormSimple;
